// covered-by: packages/schemas/src/christo/__tests__/catalyst.test.ts
import { z } from "zod";

/** kebab-case slug: lowercase letters, digits, single hyphens between segments */
export const enterpriseSlugSchema = z
  .string()
  .trim()
  .min(1)
  .max(80)
  .regex(
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    "Slug must be lowercase letters, numbers, and hyphens",
  );
